<template>
    <div class= "app-params">
        <div class="form">
            <el-form label-width="90px" :model="appParams" ref="appParams" :rules="rules">
                <div class="form-title"><span>基本信息</span></div>
                <el-form-item label="appId">
                    <el-input v-model="appParams.appId" :disabled="true"></el-input>
                    <span class="copyBtn" @click="handleCopy(appParams.appId)">复制</span>
                </el-form-item>
                <el-form-item label="appSecret">
                    <p class="appSecret">请查询应用注册通知邮件，<a @click="handleResendEmail">点击</a>后重新发送到注册邮箱</p>
                </el-form-item>
                <el-form-item label="应用图标" prop='appIcon'>
                    <el-upload
                        class="avatar-uploader"
                        :action="uploadURL"
                        :show-file-list="false"
                        :headers="headers"
                        name="fileName"
                        :on-success="handleAvatarSuccess"
                        :before-upload="beforeAvatarUpload">
                        <img v-if="appParams.appIcon" :src="appParams.appIcon" class="avatar">
                        <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                    </el-upload>
                </el-form-item>
                <el-form-item label="应用名称" prop='appName'>
                    <el-input v-model="appParams.appName"></el-input>
                </el-form-item>
                <el-form-item label="应用类型" prop='appType'>
                    <el-select v-model="appParams.appType" placeholder="请选择应用类型">
                        <el-option label="社区" value="1"></el-option>
                        <el-option label="工具" value="2"></el-option>
                        <el-option label="物业App" value="3"></el-option>
                        <el-option label="生活服务" value="4"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="是否有应用积分" prop='useIntegral'  class="double-line">
                    <el-radio-group v-model="appParams.useIntegral">
                    <el-radio :label="1">有</el-radio>
                    <el-radio :label="0">没有</el-radio>
                    </el-radio-group>
                </el-form-item>
                <el-form-item v-if="appParams.useIntegral" style="margin:0px; over-flow:hidden;"></el-form-item>
                <el-form-item v-if="appParams.useIntegral" label="应用内积分名称" prop='integralName' class="double-line">
                    <el-input v-model.number="appParams.integralName" placeholder="请填写应用积分的个性化命名，如：金币，经验值" style="width:340px;"></el-input>
                </el-form-item>
                <el-form-item v-if="appParams.useIntegral" label="积分汇率" prop='integralRatio' class="no-left-border">
                    <el-input type="number" v-model.number="appParams.integralRatio">
                        <div slot="append">积分=1元</div>
                    </el-input>
                </el-form-item>
                <div class="form-title"><span>接口配置</span></div>
                <div class="tips">
                    <p>用来向您的服务端通知充电结果的接口<a href="https://showdoc.sharecharger.com/web/#/1?page_id=7" target="_black">技术文档</a></p>
                </div>
                <el-form-item label="是否开启">
                    <el-radio-group v-model="appParams.blChargeNotify">
                    <el-radio :label="1">是</el-radio>
                    <el-radio :label="0">否</el-radio>
                    </el-radio-group>
                </el-form-item>
                <el-form-item label="接口地址" prop='chargerResultUrl'  class="long-item" v-if="appParams.blChargeNotify">
                    <el-input v-model="appParams.chargerResultUrl" placeholder="请输入充电结果接口地址"></el-input>
                </el-form-item>
                <div class="tips" v-if="appParams.useIntegral">
                    <p>用来向您的服务器提交扣除积分接口，配置后用户可用积分消费<a href="https://showdoc.sharecharger.com/web/#/1?page_id=7" target="_black">技术文档</a></p>
                </div>
                <el-form-item label="是否开启" v-if="appParams.useIntegral">
                    <el-radio-group v-model="integralDeductionUrl">
                    <el-radio :label="1">是</el-radio>
                    <el-radio :label="0" disabled >否</el-radio>
                    </el-radio-group>
                </el-form-item>
                <el-form-item label="接口地址" prop='integralDeductionUrl' class="long-item" v-if="appParams.useIntegral">
                    <el-input v-model="appParams.integralDeductionUrl" placeholder="请输入扣除积分接口地址">
                    </el-input>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="submitForm('appParams')">保存</el-button>
                </el-form-item>
            </el-form> 
        </div>
    </div>
</template>
<script>
import {http, apiJson, baseURL} from '@/utils/http'
import { Message } from 'element-ui';
export default {
    data () {
        var checkIntegralRatio = (rule, value, callback) => {
            if (!Number.isInteger(value)) {
                callback(new Error('请输入数字值'));
            } else {
                callback();
            }
        };
        return {
            appCreated: false,
            integralDeductionUrl: 1,
            appParams: {
                appId: '',
                appName: '',
                appType: '',
                useIntegral: 0,
                integralName: '',
                integralRatio: '',
                appIcon: '',
                blChargeNotify: 1,
                chargerResultUrl: '',
                integralDeductionUrl: ''
            },
            headers: {
                'token': localStorage.getItem('token')
            },
            rules: {
                appIcon: [
                    { required: true, message: '请上传应用图标', trigger: 'change' }
                ],
                appName: [
                    { required: true, message: '请输入应用名称', trigger: 'blur' },
                    { min: 1, max: 10, message: '长度在 1 到 10 个字符', trigger: 'blur' }
                ],
                appType: [
                    { required: true, message: '请选择应用类型', trigger: 'change' },  
                ],
                integralName: [
                    { required: true, message: '请输入积分名称', trigger: 'blur' },
                    { min: 1, max: 10, message: '长度在 1 到 10 个字符', trigger: 'blur' }
                ],
                integralRatio: [
                    { required: true, message: '请输入积分汇率', trigger: 'blur' },
                    { pattern: /^\d{1,4}$/, message: '请输入四位数以内的数字', trigger: 'blur' }
                ],
                chargerResultUrl: [
                    { required: true, message: '请输入接口地址', trigger: 'blur' },
                    {
                        pattern: /[\w\-_]+(\.[\w\-_]+)+([\w\-\.,@?^=%&:/~\+#]*[\w\-\@?^=%&/~\+#])?/,
                        message: '请输入正确格式的接口地址',
                        trigger: 'blur'
                    }
                ],
                integralDeductionUrl: [
                    { required: true, message: '请输入接口地址', trigger: 'blur' },
                    {
                        pattern: /[\w\-_]+(\.[\w\-_]+)+([\w\-\.,@?^=%&:/~\+#]*[\w\-\@?^=%&/~\+#])?/,
                        message: '请输入正确格式的接口地址',
                        trigger: 'blur'
                    }
                ]
            }
        }
    },
    created () {
        this.$store.commit('changeDefaultActive','param')
        let {params} = this.$route
        this.appParams.appId = params.id
        this.getAppParam(params.id)
    },
    methods: {
        getAppParam (appId) {
            http(apiJson.getappparam, {appId}).then(res => {
                //console.log(res)
                if(res.code == 0 && res.data != "未查询到指定应用") {
                    this.appParams.appId = res.data.appId
                    this.appParams.appIcon = res.data.appIcon
                    this.appParams.appName = res.data.appName
                    this.appParams.appType = res.data.appType
                    this.appParams.useIntegral = res.data.useIntegral
                    this.appParams.integralName = res.data.integralName 
                    this.appParams.integralRatio = res.data.integralRatio
                    this.appParams.chargerResultUrl = res.data.chargerResultUrl
                    this.appParams.integralDeductionUrl = res.data.integralDeductionUrl
                    this.appParams.blChargeNotify = res.data.blChargeNotify
                    this.appCreated = true
                }else if(res.code == 0) {
                    this.appCreated = false
                }else {
                    this.$router.push("/login")
                }
            })
        },
        handleAvatarSuccess (res, file) {
            this.appParams.appIcon = res.data.url;
            console.log(res)
        },
        handleResendEmail () {
            let {params} = this.$route
            //console.log(params.id)
            if(params.id) {
                http(`${apiJson.resendEmail}/${params.id}`).then(res => {
                    console.log(res)
                    if(res.code == 0) {
                        Message.success(res.data)
                    } else {
                        Message.error(res.message)
                    }
                })
            }
        },
        beforeAvatarUpload (file) {
            const isJPG = file.type === 'image/png';
            const isLt2M = file.size / 1024 / 1024 < 1;

            if (!isJPG) {
            this.$message.error('上传头像图片只能是 PNG 格式!');
            }
            if (!isLt2M) {
            this.$message.error('上传头像图片大小不能超过 1MB!');
            }
            return isJPG && isLt2M;
        },
        submitForm (loginForm) {
            this.$refs[loginForm].validate(valid => {
                if (valid) { 
                    let url
                    if(this.appCreated == false) {
                        url = apiJson.saveparam
                    }else {
                        url = apiJson.updateparam
                    }
                    let options = this.appParams
                    if(!this.appParams.blChargeNotify) {
                        options.chargerResultUrl = ''
                    }
                    if(!this.appParams.useIntegral || !this.integralDeductionUrl) {
                        console.log("sss")
                        options.integralDeductionUrl = ''
                        options.integralName = ''
                        options.integralRatio = ''
                    }
                    http(url, options).then(res => {
                        if(res.code == 0) {
                            Message.success(res.data)
                            this.getAppParam(this.appParams.appId)
                        }else {
                            Message.error('接口错误 ' + res.data)
                        }
                    })
                }
            })
        },
        handleCopy (str) {
            // 创建'虚拟'DOM
            const input = document.createElement('input')
            document.body.appendChild(input)
            input.setAttribute('value', str)
            input.select()
            if (document.execCommand('copy')) {
                document.execCommand('copy')
                this.$message({
                type: 'success',
                message: '复制成功!'
                })
            }
            // 删除'虚拟'DOM
            document.body.removeChild(input)
        }
    },
    computed: {
        uploadURL () {
            return baseURL + apiJson.fileUpload
        }
    }
}
</script>
<style lang="scss" scoped>
    @import '../../assets/scss/form.scss';
    .app-params {
        border-left: 1px solid #e5e5e5;
    }
    .form{
        .form-title {
            width: 550px;
            padding-bottom: 10px;
            margin-bottom: 23px;
        }
        .tips {
            p {
                font-size: 14px;
                color: #333333;
                padding-bottom: 20px;
                a {
                    padding-left: 10px;
                    color: #409EFF;
                    text-decoration: underline;
                }
            }
        }
        .form-tip {
            line-height: 16px;
            margin-top: 5px;
        }
        .el-form {
            border: none;
            width: 620px;
        }
        .appSecret {
            font-size: 14px;
            color: #666666;
            a {
                text-decoration: underline;
                color: #409EFF;
                cursor: pointer;
            }
        }
        .form-tip {
            font-size: 12px;
            color: #999999;
            a {
                padding-left: 10px;
                color: #409EFF;
                text-decoration: underline;
            }
        }
        .copyBtn {
            margin-left: 20px;
            cursor: pointer;
        }
    } 
    .avatar-uploader .el-upload {
        border: 1px dashed #d9d9d9;
        border-radius: 6px;
        cursor: pointer;
        position: relative;
        overflow: hidden;
    }
    .avatar-uploader .el-upload:hover {
        border-color: #409EFF;
    }
    .avatar-uploader-icon {
        font-size: 28px;
        color: #8c939d;
        width: 84px;
        height: 84px;
        line-height: 84px;
        text-align: center;
    }
    .avatar {
        width: 84px;
        height: 84px;
        display: block;
    }
</style>



// WEBPACK FOOTER //
// src/pages/CreateApp/param.vue